import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Tooltip,
  IconButton,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { rsActiveMenu, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseOrdersReport } from "./UseOrdersReport";
import { UseMyPC } from "../../hooks/UseMyPC";
import { DataGrid, faIR } from "@mui/x-data-grid";
import CustomPagination from "../../components/CustomPagination";
import { deCapitalizeFirstLetter } from "../../util/Utils";
import CheckIcon from "@mui/icons-material/Check";
import RefreshIcon from "@mui/icons-material/Refresh";
import AssessmentIcon from "@mui/icons-material/Assessment";
import moment from "jalali-moment";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import DownloadIcon from "@mui/icons-material/Download";
import YesOrNoDialoge from "../../components/YesOrNoDialoge";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { useSnackbar } from "notistack";
import { toSolar } from "jdate-convert";

export default function MYGrid(props) {
  const location = useLocation();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { GetMonthlyReport, GetAnnualReport, UpdateDailyReport, ExportList } =
    UseOrdersReport();
  const [checkState, setCheckState] = useState({
    show: false,
    name: undefined,
  });
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const { myPc, updatePage, updateSort } = UseMyPC("ShamsiOrderDate", "Desc");
  const [hideState, setHideState] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [monthlyReport, setMonthlyReport] = useState();
  const [valueStart, setValueStart] = useState();
  const [valueEnd, setValueEnd] = useState();
  const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"];
  const [valueLogdate, setValueLogdate] = useState();
  const [state, setState] = useState({
    startDate: undefined,
    endDate: undefined,
  });
  var NewDate = new Date();

  var persianYear = moment(NewDate).locale("fa").format("YYYY");

  useEffect(() => {
    // if (
    //   myPc.page === 0 ||
    //   (location.state && location.state && location.state.isBack)
    // ) {
    //   return;
    // }

    setProgress(true);
    if (props.reportState == "month") {
      GetMonthlyReport(
        props.yearReport ? props.yearReport : persianYear,
        myPc,
        (callback) => {
          callback.orders?.map((m) => {
            if (m.participation == true) {
              setHideState(false);
              return;
            }
          });
          setMonthlyReport(callback);
        }
      );
    } else if (props.reportState == "year") {
      GetAnnualReport(myPc, (callback) => {
        callback.orders?.map((m) => {
          if (m.participation == true) {
            setHideState(false);
            return;
          }
        });
        setMonthlyReport(callback);
      });
    }
  }, [myPc, props.reportState, props.yearReport]);

  useEffect(() => {
    let newValueStart = valueStart?.toDate?.().toLocaleDateString("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    setState({ ...state, startDate: newValueStart });
  }, [valueStart]);

  useEffect(() => {
    let newValueEnd = valueEnd?.toDate?.().toLocaleDateString("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });

    setState({ ...state, endDate: newValueEnd });
  }, [valueEnd]);

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "orderRow",
      width: 80,
      align: "center",
      headerName: props.reportState == "month" ? "ماه" : "سال",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "shamsiOrderDate",
      headerName: "تاریخ",
      width: 180,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "orderCount",
      headerName: "تعداد",
      width: 100,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "totalPaycost",
      headerName: "مجموع پرداختی",
      width: 160,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "totalDiscount",
      headerName: "تخفیف",
      width: 130,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "deliverycost",
      headerName: "هزینه ارسال",
      width: 130,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "participationShare",
      headerName: "سهم مشارکت",
      width: 130,
      align: "center",
      headerAlign: "center",
      hide: hideState,
    },
    {
      field: "عملیات",
      sortable: false,
      width: 130,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <>
            <Tooltip title="refresh">
              <IconButton
                onClick={() => {
                  var update = {
                    OrderDate: cellValues.row.orderdate.split("T")[0],
                  };
                  setProgress(true);
                  UpdateDailyReport(update, (callbacks) => {
                    if (props.reportState == "month") {
                      GetMonthlyReport(
                        props.yearReport ? props.yearReport : persianYear,
                        myPc,
                        (callback) => {
                          setMonthlyReport(callback);
                        }
                      );
                    } else if (props.reportState == "year") {
                      GetAnnualReport(myPc, (callback) => {
                        setMonthlyReport(callback);
                      });
                    }
                  });
                }}
              >
                <RefreshIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="daily">
              <IconButton
                onClick={() => {
                  let date = cellValues.row.orderdate.split("T")[0];
                  if (props.reportState == "month") {
                    let month = moment(date).locale("fa").format("MM");
                    props.setMonthReport(month);
                  } else if (props.reportState == "year") {
                    let year = moment(date).locale("fa").format("YYYY");
                    props.setYearReport(year);
                  }
                }}
              >
                <CalendarMonthIcon fontSize="small" color="secondary" />
              </IconButton>
            </Tooltip>
            <Tooltip title="details">
              <IconButton
                onClick={() => {
                  return navigate("/ordersreport/OrderReportDetails", {
                    state: {
                      name: props.reportState == "month" ? "ماهانه" : "سالانه",
                      ReportName:
                        props.reportState == "month"
                          ? cellValues.row.shamsiOrderDate +
                            " " +
                            props.yearReport
                          : cellValues.row.shamsiOrderDate,
                      startDate: cellValues.row.startDate,
                      endDate: cellValues.row.endDate,
                      yearReport: props.yearReport,
                      monthReport: props.monthReport,
                      reportState: props.reportState,
                    },
                  });
                }}
              >
                <AssessmentIcon
                  fontSize="small"
                  sx={{ color: "MyColor.main" }}
                />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
  ];

  return (
    <Box sx={{ pb: "20px", height: "100%" }}>
      <Dialog
        sx={{ zIndex: 1 }}
        fullWidth
        open={openDialog}
        onClose={() => {
          setState({
            startDate: undefined,
            endDate: undefined,
          });
          setOpenDialog(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          sx={{ p: 1, px: 2 }}
          color="secondary"
          id="alert-dialog-title"
        >
          <Typography variant="subtitle1">
            لطفا تاریخ شروع و پایان را انتخاب کنید
          </Typography>
        </DialogTitle>
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 3,
          }}
        >
          <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
            <DatePicker
              weekDays={weekDays}
              calendar={persian}
              locale={persian_fa}
              format="YYYY-MM-DD"
              portal
              onChange={setValueStart}
              // containerStyle={{ zIndex: 2000, position: "relative" }}
              value={state && state.startDate ? toSolar(state.startDate) : ""}
              render={
                <TextField
                  sx={{ pr: 2, input: { textAlign: "center" } }}
                  variant="outlined"
                  size="small"
                  fullWidth
                  label="تاریخ شروع"
                />
              }
            />
            <DatePicker
              weekDays={weekDays}
              calendar={persian}
              locale={persian_fa}
              format="YYYY-MM-DD"
              value={state && state.endDate ? toSolar(state.endDate) : ""}
              // value={valueEnd}
              portal
              onChange={setValueEnd}
              render={
                <TextField
                  sx={{ input: { textAlign: "center" } }}
                  variant="outlined"
                  label="تاریخ پایان"
                  size="small"
                  fullWidth
                />
              }
            />
          </Box>
          <Button
            variant="contained"
            onClick={() => {
              if (state.startDate && state.endDate) {
                setProgress(true);
                ExportList(state.startDate, state.endDate, (res) => {
                  window.open(res, "_blank");
                  setState({
                    startDate: undefined,
                    endDate: undefined,
                  });
                  setOpenDialog(false);
                });
              } else {
                enqueueSnackbar("لطفا تاریخ شروع و پایان را انتخاب کنید", {
                  variant: "error",
                  autoHideDuration: 2000,
                  preventDuplicate: true,
                });
              }
            }}
          >
            دانلود
          </Button>
        </DialogContent>
      </Dialog>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <Button
            sx={{ width: "100px", mr: 2 }}
            startIcon={props.reportState == "month" && <CheckIcon />}
            variant={props.reportState == "month" ? "contained" : "outlined"}
            onClick={() => {
              props.setReportState("month");
            }}
          >
            ماهیانه
          </Button>
          <Button
            sx={{
              width: "100px",
            }}
            startIcon={props.reportState == "year" && <CheckIcon />}
            variant={props.reportState == "year" ? "contained" : "outlined"}
            onClick={() => {
              props.setReportState("year");
            }}
          >
            سالیانه
          </Button>
        </Box>
        <IconButton
          sx={{ border: "1px solid ", borderColor: "primary.main", p: 1 }}
          onClick={() => {
            setOpenDialog(true);
          }}
        >
          <DownloadIcon fontSize="small" sx={{ color: "primary.main" }} />
        </IconButton>
      </Box>
      <Box sx={{ height: "100%", pb: "20px" }}>
        <DataGrid
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={
            monthlyReport && monthlyReport.pageCondition
              ? monthlyReport.pageCondition.pageCount
              : 1
          }
          rows={monthlyReport ? monthlyReport.orders : []}
          paginationMode="server"
          page={
            monthlyReport && monthlyReport.pageCondition
              ? monthlyReport.pageCondition.page - 1
              : 1
          }
          onPageChange={(page) => {
            updatePage(page + 1);
          }}
          rowCount={
            monthlyReport && monthlyReport.pageCondition
              ? monthlyReport.pageCondition.totalItemCount
              : 1
          }
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              scrollTo: myPc.scrollTo,
              isLtr: true,
              nofab: true,
              rowCount:
                monthlyReport && monthlyReport.pageCondition
                  ? monthlyReport.pageCondition.totalItemCount
                  : "",
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: deCapitalizeFirstLetter(myPc.sortColumn),
                  sort: deCapitalizeFirstLetter(myPc.sortOrder),
                },
              ],
            },
            pagination: {
              page: myPc.page,
            },
          }}
          onSortModelChange={(model) => {
            updateSort(model[0].field, model[0].sort == "asc" ? "asc" : "desc");
          }}
          sortingOrder={["desc", "asc"]}
          sortingMode="server"
        />
      </Box>
    </Box>
    //   {  !monthlyReport && <ProgressCom></ProgressCom>}
  );

  function month(val, year) {
    switch (val) {
      case "01":
        return "31";
      case "02":
        switch (year) {
          case "2024":
            return "29";
          case "2028":
            return "29";
          case "2032":
            return "29";
          case "2036":
            return "29";
          case "2040":
            return "29";
          default:
            return "28";
        }
      case "03":
        return "31";
      case "04":
        return "30";
      case "05":
        return "31";
      case "06":
        return "30";
      case "07":
        return "31";
      case "08":
        return "31";
      case "09":
        return "30";
      case "10":
        return "31";
      case "11":
        return "30";
      case "12":
        return "31";
      default:
        break;
    }
  }
}
